var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRecommended = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_2347_14868)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6.00008 13.9993H12.0001C12.5534 13.9993 13.0267 13.666 13.2267 13.186L15.2401 8.48601C15.3001 8.33268 15.3334 8.17268 15.3334 7.99935V6.66602C15.3334 5.93268 14.7334 5.33268 14.0001 5.33268H9.79341L10.4267 2.28602L10.4467 2.07268C10.4467 1.79935 10.3334 1.54602 10.1534 1.36602L9.44675 0.666016L5.05341 5.05935C4.81341 5.29935 4.66675 5.63268 4.66675 5.99935V12.666C4.66675 13.3993 5.26675 13.9993 6.00008 13.9993ZM6.00008 5.99935L8.89341 3.10602L8.00008 6.66602H14.0001V7.99935L12.0001 12.666H6.00008V5.99935ZM0.666748 5.99935H3.33341V13.9993H0.666748V5.99935Z",
  fill: "#3B590D"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_2347_14868"
}, /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 16,
  fill: "white"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgRecommended);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/recommended.45e1bf3ec8e6fe38b101ccf24d3d4a2f.svg";